"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schemaModel = void 0;

var _types = require("../../../types");

var WeirdBoolean = function WeirdBoolean(val) {
  return val.toLowerCase() === 'yes';
};

var schemaModel = {
  tableCatalog: {
    path: 'TableCatalog[0]',
    type: String
  },
  tableSchema: {
    path: 'TableSchema[0]',
    type: String
  },
  tableName: {
    path: 'TableName[0]',
    type: String
  },
  columnName: {
    path: 'ColumnName[0]',
    type: String
  },
  ordinalPosition: {
    path: 'OrdinalPosition[0]',
    type: Number
  },
  columnDefault: {
    path: 'ColumnDefault[0]',
    type: String
  },
  isNullable: {
    path: 'IsNullable[0]',
    type: WeirdBoolean
  },
  dataType: {
    path: 'DataType[0]',
    type: String
  },
  characterMaximumLength: {
    path: 'CharacterMaximumLength[0]',
    type: Number
  },
  characterOctetLength: {
    path: 'CharacterOctetLength[0]',
    type: Number
  },
  numericPrecision: {
    path: 'NumericPrecision[0]',
    type: Number
  },
  numericPrecisionRadix: {
    path: 'NumericPrecisionRadix[0]',
    type: Number
  },
  numericScale: {
    path: 'NumericScale[0]',
    type: Number
  },
  datetimePrecision: {
    path: 'DatetimePrecision[0]',
    type: Number
  },
  characterSetCatalog: {
    path: 'CharacterSetCatalog[0]',
    type: String
  },
  characterSetSchema: {
    path: 'CharacterSetSchema[0]',
    type: String
  },
  characterSetName: {
    path: 'CharacterSetName[0]',
    type: String
  },
  collationCatalog: {
    path: 'CollationCatalog[0]',
    type: String
  },
  collationSchema: {
    path: 'CollationSchema[0]',
    type: String
  },
  collationName: {
    path: 'CollationName[0]',
    type: String
  },
  domainCatalog: {
    path: 'DomainCatalog[0]',
    type: String
  },
  domainSchema: {
    path: 'DomainSchema[0]',
    type: String
  },
  domainName: {
    path: 'DomainName[0]',
    type: String
  },
  fieldName: {
    path: 'FieldName[0]',
    type: String
  },
  fieldPosition: {
    path: 'FieldPosition[0]',
    type: Number
  },
  fieldVocabulary: {
    path: 'FieldVocabulary[0]',
    type: String
  },
  auditAccess: {
    path: 'AuditAccess[0]',
    type: _types.BooleanAsNumber
  }
};
exports.schemaModel = schemaModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/reflection/models/schema.js
// module id = 77
// module chunks = 0